import {
  PracticeBatterSingleSessionContactPointChartConfigDto,
  PitchOrHitTypeGrouping,
  PracticeBatterSingleSessionReportChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const PracticeBatterSingleSessionContactPointChartSidebar = ({
  chartConfig,
  setTempLayout,
  tempLayout,
}: ChartConfigProps<PracticeBatterSingleSessionContactPointChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle('PracticeBatterSingleSessionContactPointChart', chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['HitType', 'PitchTypeOrGroup'] satisfies PitchOrHitTypeGrouping[]}
        selected={chartConfig.grouping}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            practiceBatterSingleSessionContactPointChartConfig: {
              ...tempLayout.practiceBatterSingleSessionContactPointChartConfig,
              grouping: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default PracticeBatterSingleSessionContactPointChartSidebar;
